import React, { useEffect, useState } from "react";
import EventTable from "./EventTable";
import Commentary from "./Commentary";
import { loadStyles } from "../../../utils/cssLoader";

const SummaryTable = ({ data, commData, id, loadCSS, dataClient, title, baseUrl }) => {
  const [activeTab, setActiveTab] = useState("events");
  const [timelineData, setTimelineData] = useState([]);
  const [commentaryData, setCommentaryData] = useState([]);

  useEffect(() => {
    if (dataClient) {
      const container = document.querySelector(".microservice-cont");
      const dataAttr = container?.getAttribute("data-listingdata");

      if (dataAttr) {
        try {
          const parsed = JSON.parse(dataAttr);
          setTimelineData(parsed?.data?.summary?.timeline || []);
          setCommentaryData(parsed?.otherData || []);
        } catch (e) {
          console.error("Failed to parse data-listingdata:", e);
        }
      }
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("matchsummary");
    }
  }, [loadCSS]);

  const renderContent = () => {
    if (activeTab === "events") {
      return (
        <EventTable data={dataClient ? timelineData : data?.timeline || []} />
      );
    } else {
      return (
        <Commentary
          data={dataClient ? commentaryData : commData || []}
          id={id}
          baseUrl={baseUrl}
        />
      );
    }
  };

  return (
    <div>
      {title && <h1>{title}</h1>}
      <nav className="inner_tab">
        <ul>
          <li
            className={activeTab === "events" ? "active" : ""}
            onClick={() => setActiveTab("events")}
          >
            <button>Events</button>
          </li>
          <li
            className={activeTab === "com" ? "active" : ""}
            onClick={() => setActiveTab("com")}
          >
            <button>Commentary</button>
          </li>
        </ul>
      </nav>

      {renderContent()}
    </div>
  );
};

export default SummaryTable;
